"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabsWithIcons = void 0;
const faAddressBook_1 = require("@fortawesome/free-solid-svg-icons/faAddressBook");
const faAward_1 = require("@fortawesome/free-solid-svg-icons/faAward");
const faBatteryFull_1 = require("@fortawesome/free-solid-svg-icons/faBatteryFull");
const faDownload_1 = require("@fortawesome/free-solid-svg-icons/faDownload");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importStar(require("react"));
const UiKitLite_1 = require("../UiKitLite");
const TabsWithIcons = () => {
    const [selectedTabIndex, setSelectedTabIndex] = (0, react_1.useState)(0);
    const tabIcons = [
        {
            icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faDownload_1.faDownload, color: 'black' }),
            position: 'left',
        },
        {
            icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faAddressBook_1.faAddressBook, color: 'brown' }),
            position: 'left',
        },
        {
            icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faBatteryFull_1.faBatteryFull, color: 'green' }),
            position: 'right',
        },
        {
            icon: react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: faAward_1.faAward, color: 'gold' }),
            position: 'right',
        },
    ];
    return (react_1.default.createElement(UiKitLite_1.UiKitLite.Tabs, { tabLabels: ['Downloads', 'Contacts', 'Energy', 'Awards'], isNumbered: false, selectedTabIndex: selectedTabIndex, setSelectedTabIndex: setSelectedTabIndex, icons: tabIcons },
        react_1.default.createElement(UiKitLite_1.UiKitLite.Tabs.TabPanel, null,
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "This is downloads content with icon to the left")),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Tabs.TabPanel, null,
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "This is contacts content with icon to the left")),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Tabs.TabPanel, null,
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "This is energy content with icon to the right")),
        react_1.default.createElement(UiKitLite_1.UiKitLite.Tabs.TabPanel, null,
            react_1.default.createElement(UiKitLite_1.UiKitLite.Text.BodyRegular, null, "This is awards content with icon to the right"))));
};
exports.TabsWithIcons = TabsWithIcons;
